angular.module('bizmetryApp').controller('JsonPathSelectorDialogController', function (
  $scope, $mdDialog, attribute, jsonSample, mappingType, currentPath, $sce
) {

  $scope.attribute = attribute;
  $scope.jsonSample = jsonSample;
  $scope.mappingType = mappingType; // 'RN' o 'RD'
  $scope.selectedPath = currentPath || null;

  console.log('JSON Path Selector opened for:', attribute.name);
  console.log('Mapping Type:', mappingType);
  console.log('Current Path:', currentPath);
  console.log('JSON Sample:', jsonSample);
  console.log('JSON Sample Type:', typeof jsonSample);

  // Parse JSON sample si es string - MEJORADO
  var parsedJson;
  try {
    if (typeof jsonSample === 'string') {
      // Primero intentar parsear directamente
      try {
        parsedJson = JSON.parse(jsonSample);
        console.log('Parsed JSON directly:', parsedJson);
      } catch (firstError) {
        // Si falla, puede ser que esté doblemente escapado o stringified
        console.log('First parse failed, trying double parse');
        var intermediate = JSON.parse(jsonSample);
        if (typeof intermediate === 'string') {
          parsedJson = JSON.parse(intermediate);
        } else {
          parsedJson = intermediate;
        }
      }
    } else if (typeof jsonSample === 'object' && jsonSample !== null) {
      parsedJson = jsonSample;
    } else {
      console.warn('Unexpected jsonSample type:', typeof jsonSample);
      parsedJson = {};
    }
    console.log('Final parsed JSON:', parsedJson);
  } catch (e) {
    console.error('Error parsing JSON sample:', e);
    console.error('Raw jsonSample:', jsonSample);
    parsedJson = {};
  }
  
  // Guardar el JSON parseado para debugging
  $scope.parsedJsonSample = parsedJson;

  // =====================================================
  // JSON PATH VALIDATION - Usando JSONPath-Plus
  // =====================================================

  /**
   * Valida que un path funcione correctamente usando JSONPath-Plus
   * y muestra una preview del valor extraído
   */
  function validateAndPreviewPath(path) {
    if (!path) {
      $scope.pathPreview = null;
      return true;
    }

    // Verificar que JSONPath esté disponible
    if (typeof JSONPath === 'undefined') {
      console.error('[validatePath] ❌ JSONPath library not loaded!');
      $scope.pathPreview = {
        valid: false,
        error: 'JSONPath library not available'
      };
      return false;
    }

    try {
      // Convertir path a formato JSONPath
      var jsonPathQuery = path;
      if (!path.startsWith('$')) {
        jsonPathQuery = '$.' + path;
      }

      console.log('[validatePath] Testing path:', path, '→', jsonPathQuery);

      // Evaluar el path
      var result = JSONPath.JSONPath({
        path: jsonPathQuery,
        json: parsedJson,
        wrap: false
      });

      console.log('[validatePath] ✅ Result:', result);

      // Guardar preview del valor
      $scope.pathPreview = {
        valid: true,
        value: result,
        type: typeof result,
        stringValue: JSON.stringify(result)
      };

      return true;

    } catch (error) {
      console.error('[validatePath] ❌ Error:', error);
      $scope.pathPreview = {
        valid: false,
        error: error.message || 'Invalid path'
      };
      return false;
    }
  }

  // ===== RENDER JSON TREE =====
  $scope.renderJsonTree = function(obj, path) {
    var html = renderJsonRecursive(parsedJson, '', 0);
    return $sce.trustAsHtml(html);
  };

  function renderJsonRecursive(obj, currentPath, level) {
    var indent = '  '.repeat(level);
    var html = '';

    if (obj === null) {
      return indent + '<span class="json-value null">null</span>';
    } 
    
    if (typeof obj !== 'object' || obj === null) {
      // Valor primitivo
      if (typeof obj === 'string') {
        return indent + '<span class="json-value string">"' + escapeHtml(obj) + '"</span>';
      } else if (typeof obj === 'number') {
        return indent + '<span class="json-value number">' + obj + '</span>';
      } else if (typeof obj === 'boolean') {
        return indent + '<span class="json-value boolean">' + obj + '</span>';
      }
    }
    
    if (Array.isArray(obj)) {
      // Array - mostrar TODOS los elementos con sus índices
      html += indent + '<span class="json-bracket">[</span>\n';
      
      if (obj.length === 0) {
        html += '<span style="color: #999; font-size: 11px; margin-left: 8px;">(empty array)</span>';
      } else {
        obj.forEach(function(item, arrayIndex) {
          var arrayPath = currentPath + '[' + arrayIndex + ']';
          var nextIndent = '  '.repeat(level + 1);
          
          html += nextIndent;
          html += '<span class="array-index-label" style="color: #4ec9b0; font-weight: 600;">[' + arrayIndex + ']</span>: ';
          
          // Renderizar cada elemento del array
          if (item === null) {
            html += renderSelectableField(arrayPath, 'null', 'null', null);
          } else if (typeof item === 'string') {
            html += renderSelectableField(arrayPath, 'string', '"' + escapeHtml(item) + '"', item);
          } else if (typeof item === 'number') {
            html += renderSelectableField(arrayPath, 'number', item, item);
          } else if (typeof item === 'boolean') {
            html += renderSelectableField(arrayPath, 'boolean', item, item);
          } else if (Array.isArray(item)) {
            // Array anidado - recursión
            html += '\n';
            html += renderJsonRecursive(item, arrayPath, level + 1);
            html += '\n' + nextIndent;
          } else if (typeof item === 'object') {
            // Objeto dentro del array - recursión
            html += '\n';
            html += renderJsonRecursive(item, arrayPath, level + 1);
            html += '\n' + nextIndent;
          }
          
          if (arrayIndex < obj.length - 1) {
            html += '<span class="json-comma">,</span>';
          }
          html += '\n';
        });
      }
      
      html += indent + '<span class="json-bracket">]</span>';
      return html;
    }
    
    // Object
    html += indent + '<span class="json-bracket">{</span>\n';
    var keys = Object.keys(obj);
    
    keys.forEach(function(key, index) {
      var value = obj[key];
      var newPath = currentPath ? currentPath + '.' + key : key;
      var isLastKey = index === keys.length - 1;
      var nextIndent = '  '.repeat(level + 1);
      
      html += nextIndent;
      html += '<span class="json-key">"' + escapeHtml(key) + '"</span>: ';
      
      // Renderizar el valor
      if (value === null) {
        html += renderSelectableField(newPath, 'null', 'null', null);
      } else if (typeof value === 'string') {
        html += renderSelectableField(newPath, 'string', '"' + escapeHtml(value) + '"', value);
      } else if (typeof value === 'number') {
        html += renderSelectableField(newPath, 'number', value, value);
      } else if (typeof value === 'boolean') {
        html += renderSelectableField(newPath, 'boolean', value, value);
      } else if (Array.isArray(value)) {
        // Array - mostrar todos los elementos
        html += '\n';
        html += renderJsonRecursive(value, newPath, level + 1);
        html += '\n' + nextIndent;
      } else if (typeof value === 'object') {
        // Objeto anidado - recursión
        html += '\n';
        html += renderJsonRecursive(value, newPath, level + 1);
        html += '\n' + nextIndent;
      }
      
      if (!isLastKey) {
        html += '<span class="json-comma">,</span>';
      }
      html += '\n';
    });
    
    html += indent + '<span class="json-bracket">}</span>';
    return html;
  }

  function renderSelectableField(path, valueType, displayValue, rawValue) {
    var isSelected = path === $scope.selectedPath;
    var fieldId = 'field_' + path.replace(/[\.\[\]]/g, '_');
    
    var classes = 'json-field selectable';
    if (isSelected) {
      classes += ' selected';
    }
    
    // Usar data attributes para el path
    var html = '<span class="' + classes + '" ';
    html += 'id="' + fieldId + '" ';
    html += 'data-path="' + escapeHtml(path) + '" ';
    html += 'data-value-type="' + valueType + '" ';
    html += 'onclick="selectFieldFromClick(this)" ';
    html += 'style="cursor: pointer;">';
    html += '<span class="json-value ' + valueType + '">' + displayValue + '</span>';
    html += '</span>';
    
    return html;
  }

  function escapeHtml(text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return String(text).replace(/[&<>"']/g, function(m) { return map[m]; });
  }

  // ===== FIELD SELECTION =====
  $scope.selectField = function(path) {
    console.log('Field selected:', path);
    $scope.selectedPath = path;
    
    // ✅ Validar y mostrar preview del path
    validateAndPreviewPath(path);
    
    // Actualizar las clases visuales
    updateFieldSelection();
  };
  
  // Función global para manejar clicks desde el HTML renderizado
  window.selectFieldFromClick = function(element) {
    var path = element.getAttribute('data-path');
    console.log('Click on field with path:', path);
    
    // Obtener el scope y aplicar cambios
    var scope = angular.element(element).scope();
    scope.$apply(function() {
      scope.selectField(path);
    });
  };
  
  function updateFieldSelection() {
    // Remover clase selected de todos los campos
    setTimeout(function() {
      var allFields = document.querySelectorAll('.json-field.selectable');
      allFields.forEach(function(field) {
        field.classList.remove('selected');
      });
      
      // Agregar clase selected al campo actual
      if ($scope.selectedPath) {
        var selectedField = document.querySelector('.json-field[data-path="' + $scope.selectedPath + '"]');
        if (selectedField) {
          selectedField.classList.add('selected');
        }
      }
    }, 50);
  }

  // ===== CLEAR SELECTION =====
  $scope.clearSelection = function() {
    $scope.selectedPath = null;
    $scope.pathPreview = null;
  };

  // ===== SAVE =====
  $scope.save = function() {
    if ($scope.selectedPath) {
      // ✅ Validar antes de guardar
      var isValid = validateAndPreviewPath($scope.selectedPath);
      
      if (isValid) {
        console.log('✅ Saving valid path:', $scope.selectedPath);
        console.log('✅ Preview value:', $scope.pathPreview);
        $mdDialog.hide($scope.selectedPath);
      } else {
        console.error('❌ Cannot save invalid path:', $scope.selectedPath);
        console.error('❌ Error:', $scope.pathPreview ? $scope.pathPreview.error : 'Unknown error');
        
        // Mostrar error al usuario
        alert('Invalid JSON Path: ' + ($scope.pathPreview ? $scope.pathPreview.error : 'Unknown error'));
      }
    }
  };

  // ===== CANCEL =====
  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  // ✅ Validar el path actual si existe
  if (currentPath) {
    validateAndPreviewPath(currentPath);
  }

});